import styled from 'styled-components';

import { PStyled } from 'approot/shared/styles/typography.style';
import { grey8 } from 'approot/shared/styles/colours.style';

export const TagOutcomeText = styled(PStyled)`
  color: ${grey8};
  margin-bottom: 0;
`;
